export interface PortalNavItem {
  id: string;
  path: string;
  title: string;
  icon: string;
  description: string;
  editSectionId?: string;
}

export const PORTAL_NAV_ITEMS: PortalNavItem[] = [
  { id: 'dashboard', path: '/dashboard', title: 'Dashboard', icon: 'IconLayoutDashboard', description: 'Your health overview' },
  { id: 'results', path: '/results', title: 'Results', icon: 'IconChartLine', description: 'Lab results and biomarkers' },
  { id: 'documents', path: '/documents', title: 'Documents', icon: 'IconFileText', description: 'Medical records and documents', editSectionId: 'documents' },
  { id: 'medications', path: '/medications', title: 'Medications', icon: 'IconPill', description: 'Medications and supplements', editSectionId: 'medications' },
  { id: 'forms', path: '/forms', title: 'Forms', icon: 'IconForms', description: 'Questionnaires and consents' },
  { id: 'insurance', path: '/insurance', title: 'Insurance', icon: 'IconShieldCheck', description: 'Insurance information', editSectionId: 'logistics' },
];

export interface LongevityDomain {
  id: string;
  title: string;
  icon: string;
  description: string;
}

export const LONGEVITY_DOMAINS: LongevityDomain[] = [
  { id: 'vascular', title: 'Vascular', icon: 'IconHeart', description: 'Cardiovascular and cerebrovascular health' },
  { id: 'metabolic', title: 'Metabolic', icon: 'IconFlame', description: 'Glucose, insulin, and metabolic function' },
  { id: 'cancer', title: 'Cancer', icon: 'IconShield', description: 'Screening and tumor markers' },
  { id: 'hormonal', title: 'Hormonal', icon: 'IconDna', description: 'Hormonal balance and optimization' },
  { id: 'inflammation', title: 'Inflammation', icon: 'IconDroplet', description: 'Systemic inflammation and immune markers' },
  { id: 'nutrition', title: 'Nutrition & Micronutrients', icon: 'IconApple', description: 'Vitamins, minerals, and nutritional status' },
];
